<template>
  <div>
    <v-dialog width = "60VW" scrollable  persistent     v-model="modals.creator">
    <creatorWrapper :modals="modals" :tasks="tasks" ></creatorWrapper>
    </v-dialog>

    <v-dialog max-width="450"  persistent    v-model="tasks.deleteTask.modal">
    <deleteTask :tasks="tasks"  ></deleteTask>
    </v-dialog>



<v-container fluid >
    <v-layout d-flex>
    <v-card>
      <v-toolbar height="42"     flat>
        <v-toolbar-title style="color:#273C51;font-size:1.6em"> Дейсвия с контентом ({{tasks.tasksList.length}}) </v-toolbar-title>


        <v-spacer></v-spacer>
        <v-btn @click="createNewTask()" flat color="#4A76A8"> <v-icon left color="#4A76A8">mdi-plus</v-icon>Создать задание</v-btn>
      </v-toolbar>
    <v-card-text>

      <div v-if="tasks.loading === true" class="text-xs-center" style="marginTop:50px" >

        <v-progress-circular
          :size="70"
          :width="7"
          color="#4A76A8"
          indeterminate
        ></v-progress-circular>

      </div>


   <div v-if="tasks.tasksList.length<=0"  style="padding-top:50px" >
   <div class="text-xs-center"><span  style="font-size:1.3em; color:#858585">  Список заданий пуст, вы можете создать новое задание.</span></div>

   </div>


     <tasksList    :tasks='tasks'> </tasksList>
   <div @click="createNewTask()" class="text-xs-center">  <v-btn  color="#4A76A8" class="white--text"><v-icon left>mdi-database-plus</v-icon>Новое задание </v-btn>  </div>










    </v-card-text>


    </v-card>

    </v-layout>
</v-container >



<v-dialog v-model="tasks.modals.accounts" width="350" persistent>
<accounts :tasks="tasks"> </accounts>
</v-dialog>

<v-dialog v-model="tasks.modals.params" width="350" persistent>
<params :tasks="tasks"> </params>
</v-dialog>


<v-dialog v-model="tasks.modals.actions" width="650" persistent>
<actions :tasks="tasks"> </actions>
</v-dialog>


<v-dialog v-model="tasks.modals.resources" max-width="900" min-width="900" max-height="500"  persistent  scrollable >
<resources :tasks="tasks"> </resources>
</v-dialog>

</div>
</template>




<script>
import axios from 'axios'
import tasksList from './tasksList.vue'
import creatorWrapper from './creator/creatorWrapper.vue'
import deleteTask from './deleteTask.vue'


import accounts from './taskParams/accounts.vue'
import params from './taskParams/params.vue'
import actions from './taskParams/actions.vue'
import resources from './taskParams/resources.vue'

 export default {
 components:{tasksList,creatorWrapper,deleteTask,accounts,params,actions,resources},
 data(){
   return {
   modals:{
     creator:false
   },
   tasks:{
     loading:true,
     modals: {
       accounts:false,
       params:false,
       logs:false,
       resources:false,
       actions: false
     },
     timeoutUpdate: '',
     deleteTask: {
       modal : false,
       taskId: {},
     },
     tasksList: [],

     task:{
      modal : false,
      info: {},
      timeoutUpdate: '',
      selectedTaskId: '',
      accounts:[],
      accountsSelected: [],
      resources: {
        foundData:{
         selector: false,
         foundIds: [],
         displayIds: [],
         selectedIds: [],
         offset: 0,
         selectAll: false
       },
       foundDataDone:{
        selector: false,
        foundIds: [],
        displayIds: [],
        selectedIds: [],
        offset: 0,
        selectAll: false
      },
     },
      actions:{
        addLikeVideo:{
          conditions:{
            modal:false
          }
        },
        commentVideo:{
          conditions:{
            modal:false
          }
        },
        topicComment:{
          conditions:{
            modal:false
          }
        },
        likePost:{
          conditions:{
            modal:false
          }
        },
        commentPost:{
          conditions:{
            modal:false
          }
        },
      },
      logs:[],
      params:{
        resourcesTimeout:{
          min: 2,
          max: 90,
          range: [1, 8]
        },
        actionsTimeout:{
          min: 5,
          max: 90,
          range: [5, 15]
        },
      },
      name: ""
    }

   },



   }
 },
methods: {
  createNewTask: function(){
    this.modals.creator = true
  },

  tasksData: function(){

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
         method: 'POST',
         data: {
           contentType: 'content'
         }
       })
       .then( response => {
        this.tasks.loading = false
           response.data.forEach(
          (item,i,arr)=>{
            item.status = JSON.parse(item.status)
          }
        )
        this.tasks.tasksList = response.data

       })

  },
},
mounted: function (){
this.tasksData()
},
beforeDestroy() {
clearTimeout(this.tasks.timeoutUpdate);
}


 }
</script>



<style>
#tasks_wrapper {
  max-width: 850px;
  min-width: 850px;
  margin-top: 15px;
  background-color: white;
  min-height: 100vh;
  border: solid 1px #E3E4E8;
  border-radius: 2px
}
</style>
